import { useTheme } from "@shared/lib/hooks/use-theme";
import { Toaster } from "@shared/ui/sonner";
import { TooltipProvider } from "@shared/ui/tooltip";
import { HotkeysProvider } from "@tanstack/react-hotkeys";
import type { ReactNode } from "react";
import { IntlProvider } from "./i18n";
import { QueryProvider } from "./query";

type TProviders = {
	children: ReactNode;
};

export function Providers({ children }: TProviders) {
	useTheme();
	return (
		<IntlProvider>
			<HotkeysProvider>
				<TooltipProvider>
					<QueryProvider>{children}</QueryProvider>
					<Toaster position={"top-right"} richColors />
				</TooltipProvider>
			</HotkeysProvider>
		</IntlProvider>
	);
}
